export default {
    methods : {
        rearrangeCategories() {
            if (!(window.innerWidth >= 768)) return;

            if (this.$refs.tabsContent) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        const categoriesWrapper = this.$refs.tabsContent.$el.querySelector('.categories-wrapper');
                        const categoryChipWrapper = this.$refs.tabsContent.$el.querySelectorAll('.category-chip-wrapper');

                        // exists one or more categories
                        if (categoriesWrapper && (categoryChipWrapper.length > 0)) {
                            categoriesWrapper.style.width = 'auto';

                            let topWidth = {};
                            // Takes every category width + 16px and get the widest for each "row".
                            // based on the max-width 30rem
                            categoryChipWrapper.forEach((category) => {
                                const elTop = category.getBoundingClientRect().top;
                                const elWidth = Math.ceil(category.getBoundingClientRect().width) + 16;
                                topWidth[elTop] = (topWidth[elTop] ? topWidth[elTop] + elWidth : elWidth);
                            });

                            // Sort all the rows based on "row top" value and the widest is applied to the categoriesWrapper div element.
                            const maxWidth = Object.keys(topWidth).reduce((acc, top) => {
                                acc.push(topWidth[top]);
                                return acc;
                            }, []).sort(function (a, b) {
                                return b - a;
                            })[0];

                            categoriesWrapper.style.width = Math.ceil(maxWidth) + 'px';
                        }

                    });
                });
            }
        },

        handleCategoriesResize() {
            this.rearrangeCategories();
        }
    },

    created() {
        window.addEventListener('resize', this.handleCategoriesResize)
    },

    mounted() {
        this.rearrangeCategories();
    },

    destroyed () {
        window.removeEventListener('resize', this.handleCategoriesResize)
    }
}